import PromoCodeActions from '../../../actions/PromoCodeActions';

export const actions = {
    getDataLink(id, success) {
        const params = {
            ids: id
        };

        PromoCodeActions.getListLinks(params, (response) => {
            success && success(response.items[0]);
        }, {});
    },

    savePromoCode(params, success) {
        PromoCodeActions.savePromoCode(params, (response) => {
            success && success(response.items[0]);
        }, {});
    } ,

    editPromoCode(params, success) {
        PromoCodeActions.editPromoCode(params, (response) => {
            success && success(response.items[0]);
        }, {});
    }
};
